module.exports = __webpack_public_path__ + "static/img/desplazamientos-3.cb8809a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/desplazamientos-3.jpg
// module id = Nmu+
// module chunks = 1